import { FC } from "react";
import { UseFormRegister } from "react-hook-form";
import { clsx } from "clsx";

interface Props {
  id: string;
  name: string;
  register: UseFormRegister<any>;
  defaultChecked: boolean;
}

const InputToggleField: FC<Props> = ({
  id,
  name,
  register,
  defaultChecked,
}): JSX.Element => {
  return (
    <div className="relative w-[44px]">
      <input
        id={id}
        type="checkbox"
        defaultChecked={defaultChecked}
        {...register(name)}
        className={clsx(["invisible peer"])}
      />
      <label
        htmlFor={id}
        className={clsx([
          "before:content-[''] before:absolute before:block before:left-0 before:top-0 before:cursor-pointer before:w-[44px] before:h-24 before:bg-gray-900 before:rounded-full before:transition-all before:duration-300",
          "after:content-[''] after:absolute after:block after:left-2 after:top-2 after:cursor-pointer after:w-20 after:h-20 after:bg-white after:rounded-full after:transition-all after:duration-300",
          "peer-checked:before:bg-yellow-500 peer-checked:after:left-[22px]",
        ])}
      ></label>
    </div>
  );
};

export default InputToggleField;
